import { render, staticRenderFns } from "./Divisive.vue?vue&type=template&id=4b1210f9&scoped=true"
import script from "./Divisive.vue?vue&type=script&lang=js"
export * from "./Divisive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1210f9",
  null
  
)

export default component.exports